import type { ButtonTypeMap } from "@mui/base/Button";
import classnames from "classnames";
import type { FunctionComponentWithRef, HTMLProps } from "react";

import { ButtonStyled } from "./styles";

export type Props = ButtonTypeMap["props"] &
  Omit<HTMLProps<HTMLButtonElement>, "as" | "ref"> & {
    className?: string;
    icon?: boolean;
    noStyle?: boolean;
    text?: boolean;
  };

export const Button: FunctionComponentWithRef<Props, HTMLButtonElement> = ({
  children,
  className,
  icon,
  noStyle,
  ref: forwardReference,
  text,
  ...props
}) => (
  <ButtonStyled
    ref={forwardReference}
    {...props}
    className={classnames(
      {
        default: !text && !noStyle,
        icon,
        text,
      },
      className,
    )}
  >
    {children}
  </ButtonStyled>
);

Button.displayName = "Button";
